/**
 * Ensures the "More payment options" control renders as a full-width pastel button.
 * Shopify's accelerated checkout uses custom elements; styling the host often
 * works better than targeting inner nodes inside shadow DOM.
 */
(function () {
  const STYLE_ID = 'brentbear-more-payment-options-style';

  const css = `
    more-payment-options-link.brentbear-more-payment-options--styled,
    .brentbear-more-payment-options-fallback {
      box-sizing: border-box;
      display: flex !important;
      align-items: center;
      justify-content: center;
      width: 100% !important;
      min-height: var(--height-buy-buttons, 47px);
      margin-block-start: var(--gap-sm, 8px);
      padding: var(--padding-md, 12px) var(--padding-lg, 16px);
      border: none;
      border-radius: var(--style-border-radius-buttons-primary, 0);
      background-color: #c8e6c9 !important;
      color: #2e5e32 !important;
      font-family: var(--button-font-family-primary, var(--font-paragraph--family));
      font-size: var(--font-paragraph--size, 1rem);
      font-weight: 600;
      line-height: 1.2;
      text-align: center;
      text-decoration: none !important;
      text-transform: var(--button-text-case-primary, none);
      cursor: pointer;
      transition: background-color 0.2s ease, color 0.2s ease;
    }

    more-payment-options-link.brentbear-more-payment-options--styled:hover,
    more-payment-options-link.brentbear-more-payment-options--styled:focus-within,
    .brentbear-more-payment-options-fallback:hover,
    .brentbear-more-payment-options-fallback:focus-visible {
      background-color: #b9dcc0 !important;
      color: #244d28 !important;
    }

    more-payment-options-link.brentbear-more-payment-options--styled a,
    more-payment-options-link.brentbear-more-payment-options--styled button,
    more-payment-options-link.brentbear-more-payment-options--styled .shopify-payment-button__more-options {
      display: flex !important;
      align-items: center;
      justify-content: center;
      width: 100% !important;
      min-height: inherit;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      background: transparent !important;
      color: inherit !important;
      font: inherit !important;
      font-weight: inherit !important;
      text-decoration: none !important;
      box-shadow: none !important;
      cursor: pointer;
    }

    .accelerated-checkout-block shopify-accelerated-checkout,
    .accelerated-checkout-block .shopify-payment-button {
      width: 100%;
    }
  `;

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  /**
   * @param {HTMLElement} link
   */
  function styleLink(link) {
    if (!(link instanceof HTMLElement) || link.dataset.brentbearStyled === 'true') return;

    link.dataset.brentbearStyled = 'true';
    link.classList.add('brentbear-more-payment-options--styled');

    const inner = link.querySelector('a, button, .shopify-payment-button__more-options');
    if (inner instanceof HTMLElement) {
      inner.style.background = 'transparent';
      inner.style.color = 'inherit';
      inner.style.width = '100%';
      inner.style.textDecoration = 'none';
    }
  }

  function scan() {
    ensureStyles();
    document.querySelectorAll('more-payment-options-link').forEach(styleLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
